<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="primary white--text py-2">
      <v-icon left color="white">mdi-filter</v-icon>
      Filtros de Búsqueda - Mis Solicitudes
      <v-spacer></v-spacer>
      <v-chip v-if="contadorFiltros > 0" color="white" text-color="primary" small>
        {{ contadorFiltros }} filtro(s) activo(s)
      </v-chip>
    </v-card-title>
    
    <v-card-text class="pt-4">
      <v-form ref="form">
        <v-tabs v-model="tab" background-color="transparent" color="primary" class="mb-4">
          <v-tab>
            <v-icon left>mdi-text-search</v-icon>
            Básicos
          </v-tab>
          <v-tab>
            <v-icon left>mdi-calendar-range</v-icon>
            Fechas
          </v-tab>
          <v-tab>
            <v-icon left>mdi-gavel</v-icon>
            Avanzados
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Tab 1: Filtros Básicos -->
          <v-tab-item>
            <v-container>
              <v-row>
                <!-- Filtro por Nro. Solicitud -->
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="filtros.solicitud_id"
                    label="Nro. Solicitud"
                    prepend-icon="mdi-pound"
                    clearable
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- Filtro por Radicado -->
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="filtros.radicado"
                    label="Radicado"
                    prepend-icon="mdi-file-document"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- Filtro por Ubicación/Paquete -->
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="filtros.ubicacion_expediente"
                    label="Paquete o Lote"
                    prepend-icon="mdi-package-variant"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- Filtro por Estado Solicitud -->
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filtros.estado_solicitud"
                    :items="estadosSolicitud"
                    item-text="text"
                    item-value="id"
                    label="Estado Solicitud"
                    prepend-icon="mdi-state-machine"
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>

                <!-- Filtro por Estado Desarchivo -->
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filtros.estado_desarchivo"
                    :items="estadosDesarchivo"
                    item-text="text"
                    item-value="id"
                    label="Estado Desarchivo"
                    prepend-icon="mdi-archive"
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- Tab 2: Filtros de Fechas -->
          <v-tab-item>
            <v-container>
              <v-row>
                <!-- Selector de tipo de fecha -->
                <v-col cols="12" md="4">
                  <v-select
                    v-model="tipoFecha"
                    :items="tiposFecha"
                    item-text="text"
                    item-value="value"
                    label="Buscar por"
                    prepend-icon="mdi-calendar-search"
                    outlined
                    dense
                  ></v-select>
                </v-col>

                <!-- Rango de fechas unificado -->
                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuFechaDesde"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="fechaDesde"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        @click:clear="limpiarFechaDesde"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :value="fechaDesde"
                      @input="setFechaDesde"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    v-model="menuFechaHasta"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="fechaHasta"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        @click:clear="limpiarFechaHasta"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :value="fechaHasta"
                      @input="setFechaHasta"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- Tab 3: Filtros Avanzados -->
          <v-tab-item>
            <v-container>
              <v-row>
                <!-- Filtro por Juzgado Solicitante -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="filtros.juzgado_solicitante_id"
                    :items="juzgados"
                    item-text="nombre"
                    item-value="id"
                    label="Juzgado Solicitante"
                    prepend-icon="mdi-gavel"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>

                <!-- Filtro por Juzgado Radicado -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="filtros.juzgado_radicado_id"
                    :items="juzgados"
                    item-text="nombre"
                    item-value="id"
                    label="Juzgado Radicado"
                    prepend-icon="mdi-gavel"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>

                <!-- Filtro por Demandante -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filtros.demandante"
                    label="Demandante"
                    prepend-icon="mdi-account-search"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- Filtro por Demandado -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filtros.demandado"
                    label="Demandado"
                    prepend-icon="mdi-account-search"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>

        <!-- Botones de acción -->
        <v-divider class="my-3"></v-divider>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn color="grey" text @click="limpiarFiltros" class="mr-2">
              <v-icon left>mdi-filter-remove</v-icon>
              Limpiar
            </v-btn>
            <v-btn color="primary" @click="aplicarFiltros" elevation="2">
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    tab: 0,
    tipoFecha: 'archivo',
    menuFechaDesde: false,
    menuFechaHasta: false,
    filtros: {
      solicitud_id: '',
      radicado: '',
      ubicacion_expediente: '',
      estado_solicitud: '',
      estado_desarchivo: '',
      juzgado_solicitante_id: '',
      juzgado_radicado_id: '',
      demandante: '',
      demandado: '',
      fecha_archivo_desde: '',
      fecha_archivo_hasta: '',
      fecha_estado_desarchivo_desde: '',
      fecha_estado_desarchivo_hasta: ''
    },
    juzgados: [],
    tiposFecha: [
      { text: 'Fecha de Archivo', value: 'archivo' },
      { text: 'Fecha Estado Desarchivo', value: 'estado_desarchivo' }
    ],
    estadosSolicitud: [
      { text: 'Pendiente', id: 1 },
      { text: 'En trámite', id: 2 },
      { text: 'Realizada', id: 3 }
    ],
    estadosDesarchivo: [
      { text: 'En Búsqueda', id: 1 },
      { text: 'Paquete Errado', id: 2 },
      { text: 'En Oficina Judicial', id: 3 },
      { text: 'En Juzgado', id: 4 },
      { text: 'Devuelto a Archivo', id: 5 }
    ]
  }),

  computed: {
    contadorFiltros() {
      let count = 0;
      Object.keys(this.filtros).forEach(key => {
        if (this.filtros[key] !== '' && this.filtros[key] !== null) {
          count++;
        }
      });
      return count;
    },
    
    fechaDesde() {
      switch(this.tipoFecha) {
        case 'archivo':
          return this.filtros.fecha_archivo_desde;
        case 'estado_desarchivo':
          return this.filtros.fecha_estado_desarchivo_desde;
        default:
          return '';
      }
    },
    
    fechaHasta() {
      switch(this.tipoFecha) {
        case 'archivo':
          return this.filtros.fecha_archivo_hasta;
        case 'estado_desarchivo':
          return this.filtros.fecha_estado_desarchivo_hasta;
        default:
          return '';
      }
    }
  },

  created() {
    this.listar_juzgados();
  },

  methods: {
    listar_juzgados() {
      axios.get('api/listar_juzgados')
        .then(response => {
          this.juzgados = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    setFechaDesde(value) {
      switch(this.tipoFecha) {
        case 'archivo':
          this.filtros.fecha_archivo_desde = value;
          break;
        case 'estado_desarchivo':
          this.filtros.fecha_estado_desarchivo_desde = value;
          break;
      }
      this.menuFechaDesde = false;
    },

    setFechaHasta(value) {
      switch(this.tipoFecha) {
        case 'archivo':
          this.filtros.fecha_archivo_hasta = value;
          break;
        case 'estado_desarchivo':
          this.filtros.fecha_estado_desarchivo_hasta = value;
          break;
      }
      this.menuFechaHasta = false;
    },

    limpiarFechaDesde() {
      switch(this.tipoFecha) {
        case 'archivo':
          this.filtros.fecha_archivo_desde = '';
          break;
        case 'estado_desarchivo':
          this.filtros.fecha_estado_desarchivo_desde = '';
          break;
      }
    },

    limpiarFechaHasta() {
      switch(this.tipoFecha) {
        case 'archivo':
          this.filtros.fecha_archivo_hasta = '';
          break;
        case 'estado_desarchivo':
          this.filtros.fecha_estado_desarchivo_hasta = '';
          break;
      }
    },

    aplicarFiltros() {
      this.$emit('filtrar', this.filtros);
    },

    limpiarFiltros() {
      this.filtros = {
        solicitud_id: '',
        radicado: '',
        ubicacion_expediente: '',
        estado_solicitud: '',
        estado_desarchivo: '',
        juzgado_solicitante_id: '',
        juzgado_radicado_id: '',
        demandante: '',
        demandado: '',
        fecha_archivo_desde: '',
        fecha_archivo_hasta: '',
        fecha_estado_desarchivo_desde: '',
        fecha_estado_desarchivo_hasta: ''
      };
      this.tipoFecha = 'archivo';
      this.$emit('limpiar');
    }
  }
};
</script>
